import { observer } from 'owa-mobx-react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import React from 'react';

import { spinner, isCompact as styles_isCompact, spinnerCircle } from './InitialLoadingPage.scss';

import classnames from 'owa-classnames';

export interface InitialLoadingPageProps {
    isCompact?: boolean;
}

const InitialLoadingPage = observer(function InitialLoadingPage(props: InitialLoadingPageProps) {
    return (
        <Spinner
            size={SpinnerSize.large}
            /* eslint-disable-next-line react-perf/jsx-no-new-object-as-prop  -- (https://aka.ms/OWALintWiki)
             * Causes extra re renders of component
             *	> JSX attribute values should not contain objects created in the same scope */
            styles={{
                root: classnames(spinner, { [styles_isCompact]: props.isCompact }),
                circle: classnames(spinnerCircle, {
                    [styles_isCompact]: props.isCompact,
                }),
            }}
        />
    );
}, 'InitialLoadingPage');

export default InitialLoadingPage;
